import { Injectable } from '@angular/core';
import { AtestadoModel } from "../models/atestado.model";
import { MarcacaoModel } from "../models/marcacao.model";
import { NumeroParaHoraPipe } from "../pipes/numero-para-hora.pipe";
import { DatePipe } from "@angular/common";
import { MedicoModel } from "../models/medico.model";
import { TiposConselhoService } from "./tipos-conselho.service";
import { TiposConselhoPrimaryKey } from "../models/tipos-conselho.model";
import { AtestadoService } from "./atestado.service";

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  constructor(private numeroParaHoraPipe: NumeroParaHoraPipe,
    private tiposConselhosService: TiposConselhoService,
    private atestadoService: AtestadoService,
    private datePipe: DatePipe) { }

  printHtmlString(titulo: string, nomePaciente: string | undefined, printContent: string | undefined, 
    medico?: MedicoModel | undefined, listaHtml?: string) {
    const windowPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

    if (nomePaciente == undefined) {
      nomePaciente = '';
    } else {
      nomePaciente = `Nome do Paciente: ${nomePaciente}`;
    }

    const listaMedicosHtml = listaHtml || '';

    windowPrint!.document.write(`
      <!doctype html>
      <html>
      <head>
        <meta charset="utf-8">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
        <style>
        @page {
            margin: 0; 
          }
          .coluna-esquerda {
             width: 35%; 
             float: left;
             padding-right: 15px;
             font-size: 9px;
             line-height: 1.2;
             margin-top: 0; 
             padding-top: 0; 
          }
          .coluna-direita {
             padding-left: 15px; 
             margin-left: 35%;
             padding-top: 0;
             margin-top: -85px; 
          }
          .clearfix::after {
              content: "";
              clear: both;
              display: table;
          }
          @media print {
            body {
              margin: 1cm; 
              padding: 0;
            }
            .container-fluid {
              margin: 0;
              padding: 0;
            }
            /* Configuração do rodapé fixo no final da página A4 */
            .print-footer {
              display: block;
              position: fixed;
              bottom: 0;
              left: 0;
              width: 100%;
              padding: 0 0 5px 0;
              background-color: white;
              text-align: center;
              font-size: 8px; /* Fonte menor */
            }
            /* Remove a quebra de linha antes do rodapé */
            .no-break {
              page-break-inside: avoid;
            }
            .coluna-esquerda {
                display: none; 
            }
            .coluna-direita {
                margin-left: 0;
                margin-top: 0;
                padding-top: 0; 
            }
          }
          .header-row {
              margin-top: 10px;
          }
          .patient-name-row {
              margin-bottom: 5px;
              border-bottom: 1px solid #000; 
          }
          /* Estilo para compactar os parágrafos do rodapé */
          .print-footer p {
              margin: 0;
              line-height: 1.1;
          }
        </style>
      </head>
      <body>
        <div class="container-fluid">
          
          <div class="row header-row">
            <div class="col-print-4">
              <img src="../../../assets/logo.png" alt="logo" class="img-fluid" style="width: 100px; float: left; margin-right: 5px;">
            </div>
            <div class="col-print-8 text-end">
              <p style="margin: 0;">${titulo}</p>
            </div>
          </div>
          
          <div class="row patient-name-row">
            <div class="col-print-12">
              <p style="font-size: 14px; margin: 5px 0 5px 0;"><b>${nomePaciente}</b></p>
            </div>
          </div>
          
          <div class="clearfix"> 
            
            <div class="coluna-esquerda">
               ${listaMedicosHtml}
            </div>

            <div class="coluna-direita">
              ${printContent}
            </div>
            
          </div>
          
         <div class="print-footer no-break">
              <hr style="border: top 1px solid black; margin: 2px 0 5px 0; width: 100%;"/>           
              
              <p style="margin-bottom: 12px;">A consulta gera direito a retorno em até 30 dias, desde que o motivo do retorno seja o mesmo da consulta.</p>
              
              <p><b>Rua Levi Coelho 43 - 2º andar Santa Efigênia BELO HORIZONTE MG</b></p>
              <p><b>CEP: 32.260-000&nbsp;|&nbsp;www.fgr.org.br&nbsp;|&nbsp;Telefone: (31)3217-0416, (31)98511-2755 e (31)98978-3342&nbsp;|&nbsp;clinicadesaude@fgr.org.br</b></p>
          </div>
          
        </div>
      </body>
      </html>
    `);

    windowPrint!.document.close();
    windowPrint!.onload = function () {
      windowPrint!.focus();
      windowPrint!.print();
      windowPrint!.close();
    };
  }


  printAtestado(atestado: AtestadoModel, marcacao: MarcacaoModel, medico: MedicoModel) {
    const tipoConselhoPk = Object.assign(new TiposConselhoPrimaryKey(), { tipo_Conselho: medico.tipo_Conselho });
    this.tiposConselhosService.get(tipoConselhoPk).subscribe(res => {
      const tipoConselho = res.data?.descricao ?? '';
      const titulo = this.atestadoService.obterTituloAtestadoPorTipo(atestado.ind_Tipo);
      const html = this.obterCorpoAtestado(atestado, marcacao, medico, tipoConselho);


      this.printHtmlString(titulo, marcacao.beneficiario?.nome_Beneficiario, html, medico,
        `${medico.tipo_Conselho} ${medico.sigla_UF ?? ''} ${medico.num_Conselho}`);
    });
  }

  private obterCorpoAtestado(atestado: AtestadoModel, marcacao: MarcacaoModel, medico: MedicoModel, tipoConselho: string): string {
    switch (atestado.ind_Tipo) {
      case 'A1':
      case 'A6':
        return `
          <p>Ao Sr.(a).</p>
          <br /><br />
          <p>
            Atesto para os devidos fins que o Sr(a).: ${marcacao?.beneficiario?.nome_Beneficiario} necessita de ${(atestado.dias_Dispensa ?? 0).toString()?.padStart(2, '0')} dias de licença
            a partir de ${this.datePipe.transform(atestado.data_Dispensa, 'dd/MM/yyyy')} CID ${atestado.cid10?.cid_10}.
          </p>
          <br />
          <p>
            <b>
              Eu ${marcacao?.beneficiario?.nome_Beneficiario}, autorizo o Dr.(a). ${medico?.nome} a registrar o diagnóstico codificado CID ou por extenso
              neste atestado médico.
            </b>
          </p>
          <br /><br />
          <p>Atenciosamente,</p>
          <br />
          <p><b>BELO HORIZONTE MG ${this.datePipe.transform(atestado.data_Dispensa, 'dd/MM/yyyy')}</b></p>
          <br />
          <br />

          <div class="row">
            <div class="col-print-4"></div>
            <div class="col-print-8">
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-print-4"></div>
            <div class="col-print-8">
              <p class="text-center">${medico?.nome} - ${tipoConselho} ${medico?.sigla_UF} ${medico.num_Conselho}</p>
            </div>
          </div>
        `;
      case 'A3':
        return `
          <p>
            Atesto para os devidos fins que o Sr(a).: ${marcacao?.beneficiario?.nome_Beneficiario}
          </p>
          <p>
            Não apresenta ao exame clínico de rotina realizado nesta data, sinais de doenças infectocontagiosas de alteração
            evidentes dos órgãos dos sentidos ou vícios de conformação física. Durante a entrevbista nao foram evidenciados
            sinais de déficit ou doença neuropsiquiátrica. Poderá participar de atividades físicas próprias para a idade, sob
            supervisão.
          </p>
          <br /><br />
          <p>Atenciosamente,</p>
          <br />
          <p><b>BELO HORIZONTE MG ${this.datePipe.transform(atestado.data_Dispensa, 'dd/MM/yyyy')}</b></p>
          <br />
          <br />

          <div class="row">
            <div class="col-print-4"></div>
            <div class="col-print-8">
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-print-4"></div>
            <div class="col-print-8">
              <p class="text-center">${medico?.nome} - ${tipoConselho} ${medico?.sigla_UF} ${medico.num_Conselho}</p>
            </div>
          </div>
        `;
      case 'A4':
        return `
          <p>
            Declaro para os devidos fins que o Sr(a) ${marcacao?.beneficiario?.nome_Beneficiario} compareceu nesta <b>Clínica de Saúde FGR</b>
            no dia ${this.datePipe.transform(atestado.data_Dispensa, 'dd/MM/yyyy')} às ${this.numeroParaHoraPipe.transform(atestado.hora_Inicial_Atd)} horas a fim de ${atestado.motivo_Declaracao}
            com saída às ${this.numeroParaHoraPipe.transform(atestado.hora_Final_Atd)} horas.
          </p>
          <br /><br />
          <p>Por ser verdade, firmo o presente.</p>
          <br />
          <p><b>BELO HORIZONTE MG ${this.datePipe.transform(atestado.data_Dispensa, 'dd/MM/yyyy')}</b></p>
          <br />
          <br />

          <div class="row">
            <div class="col-print-4"></div>
            <div class="col-print-8">
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-print-4"></div>
            <div class="col-print-8">
              <p class="text-center">${medico?.nome} - ${tipoConselho} ${medico?.sigla_UF} ${medico.num_Conselho}</p>
            </div>
          </div>
        `;
      case 'A5':
        return `
          <p>
            Atesto para os devidos fins que o Sr(a).: ${atestado.nome_Encaminhamento}
          </p>
          <p>
            Compareceu nesta <b>Clínica de Saúde FGR</b> no dia ${this.datePipe.transform(atestado.data_Dispensa, 'dd/MM/yyyy')}
            às ${this.numeroParaHoraPipe.transform(atestado.hora_Inicial_Atd)} horas, a fim de acompanhar o(a) Sr(a) ${marcacao?.beneficiario?.nome_Beneficiario}
            com saída às ${this.numeroParaHoraPipe.transform(atestado.hora_Final_Atd)} horas.
          </p>
          <br /><br />
          <p>Por ser verdade, firmo o presente.</p>
          <br />
          <p><b>BELO HORIZONTE MG ${this.datePipe.transform(atestado.data_Dispensa, 'dd/MM/yyyy')}</b></p>
          <br />
          <br />

          <div class="row">
            <div class="col-print-4"></div>
            <div class="col-print-8">
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-print-4"></div>
            <div class="col-print-8">
              <p class="text-center">Atendente</p>
            </div>
          </div>
        `;

      default:
        return '';
    }
  }
}
